import { render, staticRenderFns } from "./info-product.vue?vue&type=template&id=5be7e862&scoped=true"
import script from "./info-product.vue?vue&type=script&lang=js"
export * from "./info-product.vue?vue&type=script&lang=js"
import style0 from "./info-product.vue?vue&type=style&index=0&id=5be7e862&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7e862",
  null
  
)

export default component.exports